var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46967 0.807912C7.54158 0.736004 7.62445 0.68175 7.71291 0.645151C7.80134 0.608481 7.89831 0.588242 8 0.588242C8.10169 0.588242 8.19866 0.608481 8.28709 0.645151C8.37555 0.68175 8.45842 0.736004 8.53033 0.807912L12.4421 4.71968C12.735 5.01257 12.735 5.48744 12.4421 5.78034C12.1492 6.07323 11.6743 6.07323 11.3814 5.78034L8.75 3.1489V9.16177C8.75 9.57598 8.41421 9.91177 8 9.91177C7.58579 9.91177 7.25 9.57598 7.25 9.16177V3.1489L4.61857 5.78034C4.32567 6.07323 3.8508 6.07323 3.55791 5.78034C3.26501 5.48744 3.26501 5.01257 3.55791 4.71968L7.46967 0.807912ZM2.25 9.50001C2.25 9.08579 1.91421 8.75001 1.5 8.75001C1.08579 8.75001 0.75 9.08579 0.75 9.50001V14.5C0.75 14.9142 1.08579 15.25 1.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V9.50001C15.25 9.08579 14.9142 8.75001 14.5 8.75001C14.0858 8.75001 13.75 9.08579 13.75 9.50001V13.75H2.25V9.50001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoShare);
export default __webpack_public_path__ + "static/media/ico_share.4fc7875b1fcc86b053b27a47ab719e23.svg";
export { ForwardRef as ReactComponent };